<template>
    <div :class="`badge ${this.color}`">
        <span>{{this.text}}</span>
    </div>
</template>

<script>
export default {
    name: 'Badge',
    props: {
      color: String,
      text: String
    },
    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/common/badge.scss';
    
</style>